import cls from "./cartButton.module.scss";
import ShoppingCart2FillIcon from "remixicon-react/ShoppingCart2FillIcon";
import dynamic from "next/dynamic";
import { useMediaQuery } from "@mui/material";
import { useAppDispatch, useAppSelector } from "hooks/useRedux";
import { toggleCartButton } from "redux/slices/carts";

const DrawerContainer = dynamic(() => import("containers/drawer/drawer"));
const CartContainer = dynamic(() => import("containers/cart/cartContainer"));

type Props = {};

export default function CartButton({}: Props) {
  const dispatch = useAppDispatch();
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  const { isCartOpen, list } = useAppSelector((state) => state.carts);

  const handleClickCartButton = () => {
    dispatch(toggleCartButton());
  };

  return (
    <div className={cls.container}>
      <button
        type="button"
        className={cls.cartBtn}
        onClick={handleClickCartButton}
      >
        <ShoppingCart2FillIcon size={22} />
        {!!list.length && <div className={cls.indicator}>{list.length}</div>}
      </button>
      <DrawerContainer
        open={isCartOpen}
        onClose={handleClickCartButton}
        PaperProps={{
          style: {
            minWidth: isDesktop ? "500px" : "100%",
          },
        }}
      >
        <CartContainer />
      </DrawerContainer>
    </div>
  );
}
